import * as faComment from '@fortawesome/pro-regular-svg-icons/faComment';
export const Comment = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="${faComment.svgPathData}"/>
  </svg>
`;
